export default __webpack_public_path__ + "static/lildomains-b6caf5444592b1ff67c037b8dfbbc9ed.png";